<h2 mat-dialog-title>Change Password</h2>
<form [formGroup]="changePasswordForm">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>New Password</mat-label>
      <input matInput type="password" formControlName="newPassword" required  autocomplete="new-password" passwordrules="required: upper; required: lower; required: digit; required: [-().&@?'#,/&quot;+]" />
      @if (changePasswordForm.get('newPassword').hasError('required')) {
        <mat-error>
          Password is required
        </mat-error>
      }
    </mat-form-field>
    <app-password-strength
    [control]="changePasswordForm.get('newPassword')"></app-password-strength>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Re-type New Password</mat-label>
      <input matInput type="password" formControlName="passwordConfirmation" required  autocomplete="new-password" >
      @if (changePasswordForm.get('passwordConfirmation').hasError('required')) {
        <mat-error>Re-type New Password is required</mat-error>
      }
    </mat-form-field>
    @if (changePasswordForm.hasError('mismatch')) {
      <mat-error>
        Passwords do not match.
      </mat-error>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="changePasswordForm.invalid" (click)="onSubmit()">Submit</button>
  </mat-dialog-actions>
</form>
